var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.9526C6.51229 21.9526 2.04761 17.4879 2.04761 12.0002C2.04761 6.51254 6.51229 2.04785 12 2.04785C17.4877 2.04785 21.9524 6.51254 21.9524 12.0002C21.9524 17.4879 17.4877 21.9526 12 21.9526ZM12 2.564C6.79669 2.564 2.56376 6.79694 2.56376 12.0002C2.56376 17.2035 6.79669 21.4365 12 21.4365C17.2033 21.4365 21.4362 17.2035 21.4362 12.0002C21.4362 6.79694 17.2033 2.564 12 2.564Z",
    fill: "#F15046",
    stroke: "#F15046",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.8095C8.24518 18.8095 5.19043 15.7547 5.19043 12C5.19043 8.24518 8.24518 5.19043 12 5.19043C15.7547 5.19043 18.8095 8.24518 18.8095 12C18.8095 15.7547 15.7547 18.8095 12 18.8095ZM12 5.72317C8.53925 5.72317 5.72317 8.53872 5.72317 12C5.72317 15.4612 8.53872 18.2767 12 18.2767C15.4612 18.2767 18.2767 15.4612 18.2767 12C18.2767 8.53925 15.4612 5.72317 12 5.72317Z",
    fill: "#F15046",
    stroke: "#F15046",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2059 15.6663C13.1006 15.6663 13.0064 15.6009 12.9696 15.5021L11.7585 12.2413L8.49753 11.0298C8.39677 10.9925 8.33128 10.8953 8.3333 10.7885C8.33582 10.6812 8.40534 10.5875 8.50761 10.5542L15.3374 8.34524C15.4276 8.31602 15.5263 8.3402 15.5928 8.40669C15.6598 8.47369 15.6835 8.57243 15.6543 8.6621L13.4452 15.492C13.4124 15.5938 13.3182 15.6638 13.2109 15.6663H13.2059Z",
    fill: "#F15046"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0416 11.8091L9.35245 10.8101L15.0235 8.97594L13.1893 14.6467M13.2059 15.6663C13.1006 15.6663 13.0064 15.6009 12.9696 15.5021L11.7585 12.2413L8.49753 11.0298C8.39677 10.9925 8.33128 10.8953 8.3333 10.7885C8.33582 10.6812 8.40534 10.5875 8.50761 10.5542L15.3374 8.34524C15.4276 8.31602 15.5263 8.3402 15.5928 8.40669C15.6598 8.47369 15.6835 8.57243 15.6543 8.6621L13.4452 15.492C13.4124 15.5938 13.3182 15.6638 13.2109 15.6663H13.2059Z",
    stroke: "#F15046",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2327 16.7139C11.1339 16.7139 11.041 16.6536 11.0045 16.5553L10.0402 13.9595L7.44442 12.9951C7.3184 12.9484 7.25418 12.8082 7.30089 12.6822C7.3476 12.5562 7.48772 12.492 7.61374 12.5387L10.3141 13.542C10.3803 13.5668 10.4328 13.6189 10.4576 13.6855L11.4609 16.386C11.5076 16.512 11.4434 16.6521 11.3173 16.6988C11.2891 16.709 11.2609 16.7139 11.2327 16.7139Z",
    fill: "#F15046",
    stroke: "#F15046",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.14286C11.711 4.14286 11.4763 4.03677 11.4763 3.90605V1.2368C11.4763 1.10609 11.711 1 12.0001 1C12.2893 1 12.5239 1.10609 12.5239 1.2368V3.90605C12.5239 4.03677 12.2893 4.14286 12.0001 4.14286Z",
    fill: "#F15046",
    stroke: "#F15046",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7632 12.5242H20.094C19.9633 12.5242 19.8572 12.2895 19.8572 12.0004C19.8572 11.7112 19.9633 11.4766 20.094 11.4766H22.7632C22.8939 11.4766 23 11.7112 23 12.0004C23 12.2895 22.8939 12.5242 22.7632 12.5242Z",
    fill: "#F15046",
    stroke: "#F15046",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 23.0003C11.711 23.0003 11.4763 22.8942 11.4763 22.7635V20.0942C11.4763 19.9635 11.711 19.8574 12.0001 19.8574C12.2893 19.8574 12.5239 19.9635 12.5239 20.0942V22.7635C12.5239 22.8942 12.2893 23.0003 12.0001 23.0003Z",
    fill: "#F15046",
    stroke: "#F15046",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90605 12.5242H1.2368C1.10609 12.5242 1 12.2895 1 12.0004C1 11.7112 1.10609 11.4766 1.2368 11.4766H3.90605C4.03677 11.4766 4.14286 11.7112 4.14286 12.0004C4.14286 12.2895 4.03677 12.5242 3.90605 12.5242Z",
    fill: "#F15046",
    stroke: "#F15046",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.4553646c3334edb90bf2edd4748665c0.svg";
export { ForwardRef as ReactComponent };